/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsDip204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsDip505Schema = z.any();

export const optionsDipMutationResponseSchema = z.lazy(() => optionsDip204Schema);
